import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { RevenueIntelligence5Market, Integer } from 'ri-api-client';
import { ConfigService } from '../config.service';
import * as objectPath from 'object-path';

export interface ApiError extends Error {
  code?: number;
}

@Injectable()
export class ApiService {

  public client: RevenueIntelligence5Market;

  constructor(
    private oAuth: OAuthService
  ) {}

  init(): void {
    this.client = new RevenueIntelligence5Market({
      baseUri: ConfigService.app.baseUri,
      headers: {
        Authorization: 'Bearer ' + this.oAuth.getAccessToken()
      }
    });
  }

  destroy(): void {
    this.client = new RevenueIntelligence5Market({
      headers: {}
    });
  }

  handleResponse(response) {
    if (response.responseCode >= 400) {
      const err: ApiError = new Error(objectPath.coalesce(response, ['bodyRaw.exceptionMessage', 'bodyRaw.message'], `Error code: ${response.responseCode}.`));
      err.code = response.responseCode;
      throw err;
    } else {
      return response.bodyRaw;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api.service.ts